
const headers = [
    {
      label: 'ประเภทเนื้อหา',
      field: 'Description',
    },
    {
      label: 'แก้ไขข้อมูลล่าสุด',
      field: 'UpdateDate',
      tdClass: 'text-center',
    },
    {
      label: 'จัดการ',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers